import { Box, Button, Link, Text } from '@rbilabs/universal-components';

import Trophy from 'components/icons/trophy';
import { getDesignToken, primitive, spacing } from 'styles/constants';
export const QuestCallToAction = Button.withConfig({
  backgroundColor: primitive.$meltyYellow,
  textDecorationColor: primitive.$meltyYellow,
  _text: {
    color: primitive.$bbqBrown,
  },
  _hover: {
    backgroundColor: '#E59900',
  },
  _pressed: {
    backgroundColor: '#CC8800',
  },
});

export const QuestBadgeIcon = Trophy.withConfig({
  height: '$3',
  marginRight: spacing.$0_5,
});

export const QuestBadgeText = Text;

export const ImageWrapper = Box.withConfig({
  height: '$48',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: getDesignToken('background-default'),
});

export const ReloadButton = Button.withConfig({
  variant: 'outline',
  borderColor: getDesignToken('border-color-error'),
  _text: {
    variant: 'copyTwo',
    fontSize: 'sm',
    color: getDesignToken('text-error'),
  },
});

export const QuestCardContainer = Box.withConfig({
  borderRadius: 'xl',
  backgroundColor: getDesignToken('background-pattern'),
  shadow: '1',
  width: {
    base: 'full',
    md: '$96',
  },
  maxWidth: '100%',
  maxHeight: 'auto',
});

export const StyledLink = Link.withConfig({
  _web: { cursor: 'pointer' },
});
